import type { Lesson } from '@yuan-math/curriculum';
import { ARITHMETIC_LESSONS } from './arithmetic.ts';
import { GRADE_THREE_LESSONS } from './grade-three.ts';
import { GRADE_FOUR_LESSONS } from './grade-four.ts';
import { GRADE_FIVE_LESSONS } from './grade-five.ts';
import { FRACTION_LESSONS } from './fractions.ts';
import { DECIMAL_LESSONS } from './decimals.ts';
import { GEOMETRY_LESSONS } from './geometry.ts';
import { ALGEBRA_LESSONS } from './algebra.ts';
import { NUMBER_MIDDLE_LESSONS } from './number-middle.ts';
import { RATIO_LESSONS } from './ratios.ts';
import { EXPRESSION_LESSONS } from './expressions.ts';
import { LINEAR_EXPRESSION_LESSONS } from './linear-expressions.ts';
import { GEOMETRY_MIDDLE_LESSONS } from './geometry-middle.ts';
import { STATISTICS_LESSONS } from './statistics.ts';
import { RATIONAL_NUMBER_LESSONS } from './rational-numbers.ts';
import { PROPORTION_LESSONS } from './proportion.ts';
import { EQUATION_LESSONS } from './equations.ts';
import { GEOMETRY_UPPER_LESSONS } from './geometry-upper.ts';
import { PROBABILITY_LESSONS } from './probability.ts';
import { EXPONENT_RULE_LESSONS } from './exponent-rules.ts';
import { ROOT_LESSONS } from './roots.ts';
import { FUNCTION_LESSONS } from './functions.ts';
import { GEOMETRY_EIGHT_LESSONS } from './geometry-eight.ts';
import { SCATTER_LESSONS } from './scatter.ts';
import { ALGEBRA_FOUNDATION_LESSONS } from './algebra-foundations.ts';
import { ALGEBRA_ONE_LINEAR_LESSONS } from './algebra-one-linear.ts';
import { POLYNOMIAL_LESSONS } from './polynomials.ts';
import { QUADRATIC_LESSONS } from './quadratics.ts';
import { ALGEBRA_ONE_LESSONS } from './algebra-one.ts';
import { GEOMETRY_PROOF_LESSONS } from './geometry-proof.ts';
import { GEOMETRY_HS_LESSONS } from './geometry-hs.ts';
import { ALGEBRA_TWO_LESSONS } from './algebra-two.ts';
import { FUNCTIONS_HS_LESSONS } from './functions-hs.ts';
import { PRECALCULUS_LESSONS } from './precalculus.ts';
import { DISCRETE_LESSONS } from './discrete.ts';
import { GRADE_ELEVEN_LESSONS } from './grade-eleven.ts';
import { CALCULUS_LESSONS } from './calculus.ts';
import { INTEGRATION_TECHNIQUE_LESSONS } from './integration-techniques.ts';
import { INTEGRAL_APPLICATION_LESSONS } from './integral-applications.ts';
import { SERIES_LESSONS } from './series.ts';
import { PARAMETRIC_POLAR_LESSONS } from './parametric-polar.ts';
import { LINEAR_ALGEBRA_LESSONS } from './linear-algebra.ts';
import { PROBABILITY_UNIVERSITY_LESSONS } from './probability-university.ts';
import { RANDOM_VARIABLE_LESSONS } from './random-variables.ts';
import { DISTRIBUTION_LESSONS } from './distributions.ts';
import { INFERENCE_LESSONS } from './inference.ts';

export const LESSONS: Lesson[] = [
  ...ARITHMETIC_LESSONS,
  ...GRADE_THREE_LESSONS,
  ...GRADE_FOUR_LESSONS,
  ...GRADE_FIVE_LESSONS,
  ...FRACTION_LESSONS,
  ...DECIMAL_LESSONS,
  ...GEOMETRY_LESSONS,
  ...ALGEBRA_LESSONS,
  ...NUMBER_MIDDLE_LESSONS,
  ...RATIO_LESSONS,
  ...EXPRESSION_LESSONS,
  ...GEOMETRY_MIDDLE_LESSONS,
  ...STATISTICS_LESSONS,
  ...RATIONAL_NUMBER_LESSONS,
  ...PROPORTION_LESSONS,
  ...LINEAR_EXPRESSION_LESSONS,
  ...EQUATION_LESSONS,
  ...GEOMETRY_UPPER_LESSONS,
  ...PROBABILITY_LESSONS,
  ...EXPONENT_RULE_LESSONS,
  ...ROOT_LESSONS,
  ...FUNCTION_LESSONS,
  ...GEOMETRY_EIGHT_LESSONS,
  ...SCATTER_LESSONS,
  ...ALGEBRA_ONE_LINEAR_LESSONS,
  ...ALGEBRA_FOUNDATION_LESSONS,
  ...POLYNOMIAL_LESSONS,
  ...QUADRATIC_LESSONS,
  ...ALGEBRA_ONE_LESSONS,
  ...GEOMETRY_PROOF_LESSONS,
  ...GEOMETRY_HS_LESSONS,
  ...ALGEBRA_TWO_LESSONS,
  ...FUNCTIONS_HS_LESSONS,
  ...PRECALCULUS_LESSONS,
  ...DISCRETE_LESSONS,
  ...GRADE_ELEVEN_LESSONS,
  ...CALCULUS_LESSONS,
  ...INTEGRATION_TECHNIQUE_LESSONS,
  ...INTEGRAL_APPLICATION_LESSONS,
  ...SERIES_LESSONS,
  ...PARAMETRIC_POLAR_LESSONS,
  ...LINEAR_ALGEBRA_LESSONS,
  ...PROBABILITY_UNIVERSITY_LESSONS,
  ...RANDOM_VARIABLE_LESSONS,
  ...DISTRIBUTION_LESSONS,
  ...INFERENCE_LESSONS,
];

export {
  ARITHMETIC_LESSONS,
  GRADE_THREE_LESSONS,
  GRADE_FOUR_LESSONS,
  GRADE_FIVE_LESSONS,
  FRACTION_LESSONS,
  DECIMAL_LESSONS,
  GEOMETRY_LESSONS,
  ALGEBRA_LESSONS,
  NUMBER_MIDDLE_LESSONS,
  RATIO_LESSONS,
  EXPRESSION_LESSONS,
  GEOMETRY_MIDDLE_LESSONS,
  STATISTICS_LESSONS,
  RATIONAL_NUMBER_LESSONS,
  PROPORTION_LESSONS,
  LINEAR_EXPRESSION_LESSONS,
  EQUATION_LESSONS,
  GEOMETRY_UPPER_LESSONS,
  PROBABILITY_LESSONS,
  EXPONENT_RULE_LESSONS,
  ROOT_LESSONS,
  FUNCTION_LESSONS,
  GEOMETRY_EIGHT_LESSONS,
  SCATTER_LESSONS,
  ALGEBRA_ONE_LINEAR_LESSONS,
  ALGEBRA_FOUNDATION_LESSONS,
  POLYNOMIAL_LESSONS,
  QUADRATIC_LESSONS,
  ALGEBRA_ONE_LESSONS,
  GEOMETRY_PROOF_LESSONS,
  GEOMETRY_HS_LESSONS,
  ALGEBRA_TWO_LESSONS,
  FUNCTIONS_HS_LESSONS,
  PRECALCULUS_LESSONS,
  DISCRETE_LESSONS,
  GRADE_ELEVEN_LESSONS,
  CALCULUS_LESSONS,
  INTEGRATION_TECHNIQUE_LESSONS,
  INTEGRAL_APPLICATION_LESSONS,
  SERIES_LESSONS,
  PARAMETRIC_POLAR_LESSONS,
  LINEAR_ALGEBRA_LESSONS,
  PROBABILITY_UNIVERSITY_LESSONS,
  RANDOM_VARIABLE_LESSONS,
  DISTRIBUTION_LESSONS,
  INFERENCE_LESSONS,
};
